module.exports = __webpack_public_path__ + "img/thumb-013.0ddfc270.png";